import {Box} from "@chakra-ui/react";

export default function Index() {
    return (
        <>
            <Box p={4}>Use the invitation link to participate the event</Box>
        </>
    );
}
